import apiClient from './apiClient';

/**
 * @summary Service for getting Acumatica prices
 */
export class MarketplacesService {
  /**
   * @summary Get Acumatica prices for a category code
   * 
   * @param {string} catCode The category code to get prices for
   * @returns {Promise<
   *  Array<{
   *   id: 123,
   *   name: "eBay",
   *   apiLimit: 5000,
   *   apiScanLimit: 4000,
   *   active: true,
   *   daysBetweenScansMultiplier: 1,
   *   hasSoldItems: false,
   *  }>
   * >}
   */
  async getMarketplaces() {
    const response = await apiClient.getWithCache(`api/marketplaces`, { cacheDuration: 1000 * 60 * 60 });
    return response.data;
  }
}
